import styles from './ValueStatement.module.scss';

import React, { FC } from 'react';
import cx from 'classnames';

import { AppType } from 'services/cms/typesUtil';
import { FadeToastUp } from 'components/Animation/FadeToastUp/FadeToastUp';
import { ValueStatement } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'services/cms/flattenContentful';
import { SubjectMedia } from 'components/SubjectMedia/SubjectMedia';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';
import InlineGallery from 'components/InlineGallery/InlineGallery';

export type ValueStatementProps = AppType.Component<FlatEntry<ValueStatement>>;

export const ValueStatementModule: FC<ValueStatementProps> = ({
  internalName,
  richBlurb,
  items = [],
  enableModal,
  _attributes,
}) => {
  if (items.length == 0) return null;

  const isImageGallery = items.length > 1;

  return (
    <section
      id={internalName}
      className={cx(styles.valueStatementWrapper, isImageGallery && styles.isGallery)}
      {..._attributes}
    >
      <FadeToastUp>
        <div className={styles.mediaContainer}>
          {isImageGallery ? (
            <InlineGallery items={items} enableModal={enableModal} />
          ) : (
            <SubjectMedia entry={items[0]} className={styles.media} playWhenInView loop />
          )}
        </div>
      </FadeToastUp>
      <FadeToastUp>
        <div className={styles.textContainer}>
          <RichBlurb document={richBlurb} className={styles.blurb} />
        </div>
      </FadeToastUp>
    </section>
  );
};

export default ValueStatementModule;
